import React from 'react';
import { Filter, ChevronRight, ChevronDown } from 'lucide-react';
import FilterControl, { VIEW_SWITCH } from './FilterControl';

/**
 * The declared-filter panel (05 §3), derived entirely from Family metadata.
 *
 * ONE ARCHITECTURE FOR ALL TEN LISTS. The shipped Spells page is the only one
 * with a central `updateFilter` and removable chips; the other nine grew a
 * closure per control and a read-only badge summary. 05 §3 chose the Spells
 * architecture for everything, and this is it: a collapsible grid of controls,
 * one per declared filter, plus the platform `?rulebook=` control on printed
 * Families. It is the workstream's one deliberate cross-page UI change and it
 * is named in the allowlist (A17) rather than smuggled in.
 *
 * The toggle only renders when there is something behind it, so a Family that
 * declares no filter — languages, rulebooks — gets no empty affordance.
 */
export default function FilterPanel({
  filters, options, values, onChange, open, onToggle, extra, onExtraChange,
}) {
  const renderable = filters.filter((f) => f.filterPanel !== false && f.style !== VIEW_SWITCH);
  if (!renderable.length) return null;

  return (
    <>
      <div className="flex items-center justify-between">
        <button
          type="button"
          onClick={onToggle}
          className="back-link"
          aria-expanded={open}
          aria-controls="advanced-filters-panel"
        >
          <Filter className="w-4 h-4" />
          <span>Advanced Filters</span>
          {open ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
        </button>
      </div>

      {open && (
        <div
          id="advanced-filters-panel"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pt-4 border-t"
        >
          {renderable.map((filter) => (
            <FilterControl
              key={filter.urlKey}
              filter={filter}
              options={options[filter.urlKey] || []}
              value={values[filter.urlKey]}
              onChange={(value) => onChange(filter, value)}
              extra={extra}
              onExtraChange={onExtraChange}
            />
          ))}
        </div>
      )}
    </>
  );
}
